export default "/public/app-main/static/image/e7520c5702fd58d3ae5ffb0864c7db3e.png";